import DataBaseAccountingRoutes from './DataBaseAccountingRoutes';

export default DataBaseAccountingRoutes;
